import { supabase } from '../../../lib/supabase';

export function useSignOut() {
  const signOut = async () => {
    localStorage.removeItem('superadmin_org_id');
    return supabase.auth.signOut();
  };
  return { signOut };
}
